import { useState } from 'react';
// material
import {
  Box,
  Table,
  Switch,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  FormControlLabel,
  Toolbar,
  Typography,
  Tooltip,
  IconButton,
  Stack,
  Container
} from '@material-ui/core';
// eslint-disable-next-line import/no-unresolved
import Scrollbar from 'src/components/Scrollbar';
// eslint-disable-next-line import/no-unresolved
import { useSelector } from 'src/redux/store';
// eslint-disable-next-line import/no-unresolved
import SortingSelectingHead from 'src/pages/components-overview/material-ui/table/sorting-selecting/SortingSelectingHead';
// components
//

// ----------------------------------------------------------------------

import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { useTheme, styled } from '@material-ui/core/styles';
// eslint-disable-next-line import/no-unresolved
import TableListToolbar from 'src/components/table/TableListToolbar';
// eslint-disable-next-line import/no-unresolved
import useSettings from 'src/hooks/useSettings';
// eslint-disable-next-line import/no-unresolved
import PopOverCustom from 'src/components/common-components/PopOverCustom';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member, import/no-unresolved
import TableMoreMenu from 'src/components/table/TableMoreMenu';
import { filter } from 'lodash';
import TableSearchFilters from './TableSearchFilters';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

// ----------------------------------------------------------------------

SortingSelectingToolbarMaster.propTypes = {
  numSelected: PropTypes.number.isRequired,
  selectedId: PropTypes.array,
  handleDelete: PropTypes.func,
  setSelected: PropTypes.func,
  onFilterName: PropTypes.func,
  filterName: PropTypes.string
};

export function SortingSelectingToolbarMaster({
  numSelected,
  onFilterName = () => {},
  handleDelete = () => {},
  selectedId,
  filterName,
  setSelected = () => {}
}) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const [showFilter, setShowFilter] = useState(false);
  const [showNumSelect, setshowNumSelect] = useState(true);
  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: isLight ? theme.palette.text.primary : theme.palette.text.primary
        })
      }}
    >
      {numSelected > 0 && (
        <Typography color={theme.palette.primary.main} variant="subtitle1" component="div">
          {numSelected} selected
        </Typography>
      )}

      {numSelected > 0 && (
        <Tooltip title="Delete">
          <IconButton
            onClick={() => {
              handleDelete(selectedId);
              setshowNumSelect(!showNumSelect);
              setSelected([]);
            }}
          >
            <Icon color={theme.palette.primary.main} icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      )}
      {numSelected < 1 && showFilter === false && (
        <>
          <TableListToolbar
            // numSelected={selected.length}
            filterName={filterName}
            onFilterName={onFilterName}
            // switchButton={switchButton}
            // switchButtonResponse={switchButtonResponse}
            // status={status}
          />
          <PopOverCustom
            ComponentCalled={TableSearchFilters}
            iconBtn={roundFilterList}
            showbtnIcon
            title="FileManagement | Smart Collect"
          />
        </>
      )}
    </RootStyle>
  );
}

const TABLE_HEAD = [
  {
    id: 'file_name',
    numeric: false,
    disablePadding: true,
    label: 'File Name'
  },
  {
    id: 'file_size',
    numeric: false,
    disablePadding: false,
    label: 'Size'
  },
  {
    id: 'client_name',
    numeric: false,
    disablePadding: false,
    label: 'Client'
  },
  {
    id: 'project_name',
    numeric: false,
    disablePadding: false,
    label: 'Project'
  },
  {
    id: 'uploaded_by',
    numeric: false,
    disablePadding: false,
    label: 'Uploaded By'
  },
  {
    id: 'created_date',
    numeric: false,
    disablePadding: false,
    label: 'Uploaded Date'
  },
  {
    id: 'category_name',
    numeric: false,
    disablePadding: false,
    label: 'File Type'
  },
  {
    id: 'Action',
    numeric: false,
    disablePadding: false,
    label: 'Action'
  }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// function stableSort(array, comparator) {
//   const stabilizedThis = array.map((el, index) => [el, index]);
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) return order;
//     return a[1] - b[1];
//   });
//   return stabilizedThis.map((el) => el[0]);
// }

FileManagementTable.propTypes = {
  // numSelected: PropTypes.number,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func
};

export default function FileManagementTable({ handleEdit = () => {}, handleDelete = () => {} }) {
  const { themeStretch } = useSettings();
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('file_name');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filterName, setFilterName] = useState('');
  // const dispatch = useDispatch();

  const { masterFileData } = useSelector((state) => state.filemanager);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = masterFileData.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };
  const handleFilterByName = (event) => {
    // dispatch(filterComponent(event.target.value));
    setFilterName(event.target.value);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty SORTING_SELECTING_TABLE.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - masterFileData.length) : 0;

  const downloadMasterFile = (e, fileName) => {
    const outputFilename = 'MasterFile';
    const link = document.createElement('a');
    link.href = fileName;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  // searching data for passing props

  function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });

    if (query) {
      const FilterByProject = filter(
        array,
        (_product) =>
          _product.project.project_name.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          _product.client.client_name.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          _product.file_name.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          _product.created_date.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          _product.category_name.category_name.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );

      return FilterByProject;
    }

    return stabilizedThis.map((el) => el[0]);
  }
  const filteredProducts = applySortFilter(masterFileData, getComparator(order, orderBy), filterName);

  return (
    <>
      <SortingSelectingToolbarMaster
        numSelected={selected.length}
        selectedId={selected}
        setSelected={setSelected}
        handleDelete={handleDelete}
        onFilterName={handleFilterByName}
        filterName={filterName}
      />
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 2 }} />
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800, overflow: 'hidden' }}>
            <Table
              size={dense ? 'small' : 'medium'}
              sx={{
                '& .MuiTableCell-root:first-child': {
                  borderTopLeftRadius: '8px',
                  borderBottomLeftRadius: '8px',
                  boxShadow: `inset 8px 0 0 ${isLight ? '#fff' : '#212b36'}`
                },
                '& .MuiTableCell-root:last-child': {
                  borderTopRightRadius: '8px',
                  borderBottomRightRadius: '8px',
                  boxShadow: `inset -8px 0 0 ${isLight ? '#fff' : '#212b36'}`
                }
              }}
            >
              <SortingSelectingHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                rowCount={masterFileData?.length}
                onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredProducts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                  // {masterFileData?.map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow hover role="checkbox" aria-checked={isItemSelected} tabIndex={-1} key={row.id}>
                      <TableCell padding="checkbox">
                        <Checkbox onClick={(event) => handleClick(event, row.id)} checked={isItemSelected} />
                      </TableCell>
                      <TableCell style={{ paddingLeft: 0 }} component="th" id={labelId} scope="row" padding="none">
                        {row.file_name}
                      </TableCell>
                      <TableCell align="left">{row.file_size ? row.file_size : '---'}</TableCell>
                      <TableCell align="left">{row.client_name}</TableCell>
                      <TableCell align="left">{row.project_name}</TableCell>
                      {row?.Uploaded_by !== null ? (
                        <TableCell align="left">
                          {/* {row?.Uploaded_by?.first_name || '--'} {row?.Uploaded_by?.last_name || '--'} */}
                          {row?.uploaded_by || '---'}
                        </TableCell>
                      ) : (
                        <TableCell align="left" />
                      )}
                      <TableCell align="left">{row.created_date}</TableCell>
                      <TableCell align="left">{row.category_name}</TableCell>
                      <TableCell align="center">
                        <TableMoreMenu data={row} onEdit={handleEdit} onDownload={downloadMasterFile} />
                      </TableCell>
                    </TableRow>
                  );
                })}
                {filteredProducts.length === 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows
                    }}
                  >
                    <TableCell colSpan={TABLE_HEAD.length + 1} align="center">
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Scrollbar>
        <Box sx={{ position: 'relative' }}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredProducts?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          <Box
            sx={{
              px: 3,
              py: 1.5,
              top: 0,
              position: { md: 'absolute' }
            }}
          >
            <FormControlLabel control={<Switch checked={dense} onChange={handleChangeDense} />} label="Dense padding" />
          </Box>
        </Box>
      </Container>
    </>
  );
}
